var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 0C5.4355 0 0.0625 5.373 0.0625 12C0.0625 18.627 5.4355 24 12.0625 24C18.6895 24 24.0625 18.627 24.0625 12C24.0625 5.373 18.6895 0 12.0625 0ZM17.6215 8.6805L11.8735 17.466C11.872 17.4675 11.869 17.469 11.869 17.4705C11.839 17.5155 11.8225 17.5665 11.785 17.6085C11.7325 17.6655 11.665 17.6955 11.605 17.739C11.59 17.7495 11.575 17.7615 11.5585 17.772C11.4655 17.8305 11.3695 17.8695 11.2645 17.895C11.23 17.904 11.1985 17.913 11.1625 17.919C11.079 17.9305 10.9943 17.9315 10.9105 17.922C10.8513 17.9183 10.7926 17.9092 10.735 17.895C10.6756 17.8771 10.6179 17.854 10.5625 17.826C10.5145 17.8035 10.4635 17.7975 10.4185 17.769C10.3855 17.748 10.3675 17.715 10.339 17.6895C10.327 17.679 10.312 17.676 10.3 17.6655L6.9535 14.571C6.75514 14.3805 6.63942 14.1198 6.63121 13.845C6.623 13.5701 6.72296 13.303 6.9096 13.101C7.09624 12.899 7.35467 12.7783 7.62934 12.7649C7.90401 12.7514 8.173 12.8463 8.3785 13.029L10.801 15.27L15.8635 7.5315C16.0159 7.29837 16.2546 7.13532 16.5272 7.07822C16.7998 7.02112 17.0839 7.07463 17.317 7.227C17.5501 7.37937 17.7132 7.6181 17.7703 7.89069C17.8274 8.16327 17.7739 8.44738 17.6215 8.6805Z",
    fill: "#75F08A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.1b97adfb3da0bc39d8f1520393666aec.svg";
export { ForwardRef as ReactComponent };